import { Checkbox } from 'antd'
import PropTypes from 'prop-types'
import { useGetRepresentatives } from 'domains/Representative/hooks'
import { useSubfilterActions } from 'hooks'
import { StyledDetails } from '../CustomerFilter.styles'
import { useTranslations } from 'contexts/Translation'
import { Text } from '@qonsoll/react-design'

const RepresentativeFilter = ({ filterData, setFilterData }) => {
  // [ADDITIONAL_HOOKS]
  const [representatives] = useGetRepresentatives()
  const { t } = useTranslations()

  // [COMPUTED_PROPERTIES]
  const summaryStyles = { marginBottom: '8px' }

  const { onToggleDetails, onChange, checkIsEnabled } = useSubfilterActions({
    filterData,
    setFilterData,
    fieldName: 'representatives',
    operand: 'array-contains'
  })

  return (
    <StyledDetails
      open={
        localStorage.getItem(`representative-details-visibility`) === 'opened'
      }>
      <summary
        style={summaryStyles}
        onClick={() => onToggleDetails('representative')}>
        {t('Representative')}
      </summary>
      {representatives?.map((representative, index) => (
        <div key={`status-${index}`}>
          <Checkbox
            key={`status-${index}`}
            checked={checkIsEnabled(representative)}
            onChange={() => onChange(representative)}>
            <Text wordBreak="break-all">
              {representative?.birthDate || t('Unnamed filter')}
            </Text>
          </Checkbox>
        </div>
      ))}
    </StyledDetails>
  )
}

RepresentativeFilter.propTypes = {
  filterData: PropTypes.object,
  setFilterData: PropTypes.func
}

export default RepresentativeFilter
